<template>
  <component :is="!hasData ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert :show="!hasData" variant="danger">
      <h4 class="alert-heading">Erreur de récupération des données de pays</h4>
      <div class="alert-body">
        Pas de Pays trouvé sur cet identifiant. Vérifiez
        <b-link :to="{ name: 'apps-countries-list' }" class="alert-link">
          la liste des pays
        </b-link>
        pour d'autres pays.
      </div>
    </b-alert>

    <b-tabs v-if="hasData" pills>
      <!-- Tab: Général -->
      <b-tab active>
        <template #title>
          <feather-icon class="mr-0 mr-sm-50" icon="UserIcon" size="16"/>
          <span class="d-none d-sm-inline">{{ hasData ? 'Modifier' : 'Ajouter' }} Pays</span>
        </template>
        <handle-country-tab-general
            class="mt-2 pt-75"
            @data-handled="$router.push({ name: 'apps-countries-list' })"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
/* eslint-disable */
import {BAlert, BCard, BLink, BTab, BTabs} from "bootstrap-vue";
import {ref, onMounted} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import HandleCountryTabGeneral from "./HandleCountryTabGeneral.vue";

// Notification

export default {
  name: "HandleCountry",
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    HandleCountryTabGeneral,
  },
  setup() {
    const hasData = ref(true);

    const fetchCountry = () => {
      store
          .dispatch("country/fetchCountry", {id: router.currentRoute.params.id})
          .then((response) => {
            //
          })
          .catch((error) => {
            if (error.response.status === 404) {
              hasData.value = false;
            }
          })
    };

    onMounted(() => {
        store.commit('country/SET_RESOURCE', {
          name: "",
          description: "",
        });
      if (router.currentRoute.params.id) {
        fetchCountry();
      }
    });

    return {
      hasData,
    };
  },
};
</script>
